module.exports = __webpack_public_path__ + "static/media/firefox.81ab4272.svg";